import Layout from "../../../Components/Layout";
import { EventLanguage } from "../../../utils/Languages";
import EventDetails from "../../../Components/User/Events/EventDetails";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  CheckIdMerch,
} from "../../../utils/ApiConstant";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import CustomLayoutUser from "../../../Components/Layout/CustomLayoutUser";
import { SocialLinkModal } from "../../../Components/EventMgt/SocialLinkModal";

const EventDetailPage = () => {
  const { userName, eventId } = useParams();
  const { userDetails } = useSelector((state) => state.user);
  const [sharingModal, setSharingModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const EventData = useSelector((state) => state.event.data);
  const query = new URLSearchParams(window.location.search);
  const newQueryParameters = new URLSearchParams(window.location.search);
  const page = query.get("page");
  const id = query.get("id");
  const redirectUrl = query.get("redirectUrl");
  const navigate = useNavigate();
  const referralId = query.get("referralId");

  const promoteEvent = useCallback(() => {
    setSharingModal((current) => !current);
  }, []);

  const shareEvent = useCallback(() => {
    setShowShareModal(true);
  }, []);

  const closeShareModal = useCallback(() => {
    setShowShareModal(false);
  }, []);

  const shareModal = (
    <SocialLinkModal
      eventId={eventId}
      show={showShareModal}
      onHide={closeShareModal}
      isHideEmbeded={true}
    />
  );

  useEffect(() => {
    if (!!referralId) {
      (async () => {
        const response = await axios.get(`${CheckIdMerch}?id=${referralId}`);
        if (response.status === 200) {
          if (response.data?.userId) {
            newQueryParameters.delete("referralId");
            newQueryParameters.append("referralId", response.data?.userId);
            navigate(
              `/event-details/${eventId}?${newQueryParameters.toString()}`
            );
          }
        }
      })();
    }
  }, [referralId]);
  // useEffect(() => {
  //   if (userDetails === false) {
  //     window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
  //   }
  // }, [userDetails]);

  return (
    <>
      {(!userName &&
        userDetails &&
        userDetails.isPromoter &&
        EventData?.promoters?.some(
          (p) => (p?._id || p)?.toString() === userDetails._id?.toString()
        ) &&
        EventData?.isCancelled === false) ||
      id ? (
        <Layout
          Heading={EventData?.title || EventLanguage.UserEvents.details.Heading}
          HeadLabel={EventLanguage.UserEvents.details.Heading}
          HeadChip={EventData?.category}
          TitleClassName="event-details-page-title"
          HeadClassName="event-details-head"
          DetailsHead
          ExtraclassName="event-details-panel"
          SecondaryButtonHeading="Promote Event"
          SecondaryButtonIcon="bi-share"
          BackAction={
            // userDetails && page === "myevents" ? "/organizer/MyEvents" : "/"
            redirectUrl
          }
          SecondaryButtonAction={promoteEvent}
          Sidebar={userDetails === false && 0}
        >
          <EventDetails
            sharingModal={sharingModal}
            setSharingModal={setSharingModal}
          />
          {shareModal}
        </Layout>
      ) : userName ? (
        <CustomLayoutUser
          BackAction={
            redirectUrl
          }
          Heading={EventData?.title || EventLanguage.UserEvents.details.Heading}
          HeadLabel={EventLanguage.UserEvents.details.Heading}
          HeadChip={EventData?.category}
          TitleClassName="event-details-page-title"
          HeadClassName="event-details-head"
          DetailsHead
          ExtraclassName="event-details-panel"
          Sidebar={userDetails === false && 0}
          SecondaryButtonHeading="Share Event"
          SecondaryButtonIcon="bi-share"
          SecondaryButtonAction={shareEvent}
        >
          <EventDetails />
          {shareModal}
        </CustomLayoutUser>
      ) : (
        <Layout
          BackAction={
            redirectUrl
          }
          Heading={EventData?.title || EventLanguage.UserEvents.details.Heading}
          HeadLabel={EventLanguage.UserEvents.details.Heading}
          HeadChip={EventData?.category}
          TitleClassName="event-details-page-title"
          HeadClassName="event-details-head"
          DetailsHead
          ExtraclassName="event-details-panel"
          Sidebar={userDetails === false && 0}
          SecondaryButtonHeading="Share Event"
          SecondaryButtonIcon="bi-share"
          SecondaryButtonAction={shareEvent}
        >
          <EventDetails />
          {shareModal}
        </Layout>
      )}
    </>
  );
};

export default EventDetailPage;
